
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBillIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M18.75 21H5.25a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 5.25 3h9l5.25 5.25v12a.75.75 0 0 1-.75.75Z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.25 3v5.25h5.25",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.86 17.103a.545.545 0 0 1-.546-.545v-3.985c0-.301.245-.546.546-.546h2.704c1.326 0 1.856.403 1.856 1.876v.564a.545.545 0 0 1-.546.545h-.254a.545.545 0 0 1-.545-.545v-.564c0-.354-.167-.491-.51-.491h-1.31a.545.545 0 0 0-.546.545v2.6a.545.545 0 0 1-.546.546H8.86Zm6.75-3.976c-.109 2.454-.698 4.055-3.466 4.055-.263 0-.8-.028-1.192-.05a.542.542 0 0 1-.508-.495l-.163-1.867a.546.546 0 0 1 .543-.592h.187c.285 0 .521.218.544.502l.053.675c.02.258.218.467.476.493.1.01.19.018.236.018 1.62 0 1.748-.942 1.817-2.945l.008-.36a.545.545 0 0 1 .545-.534h.403c.313 0 .561.263.544.575l-.028.525Z",
  fill: "#414045"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.7507 21H5.25C4.83579 21 4.5 20.6642 4.5 20.25V3.75C4.5 3.33579 4.83579 3 5.25 3H14.2507L19.5007 8.25V20.25C19.5007 20.4489 19.4217 20.6397 19.2811 20.7803C19.1404 20.921 18.9496 21 18.7507 21Z\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M14.25 3V8.25H19.5007\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.85991 17.1033C8.55866 17.1033 8.31445 16.8591 8.31445 16.5579V12.5728C8.31445 12.2716 8.55866 12.0273 8.85991 12.0273H11.5643C12.8897 12.0273 13.4199 12.4299 13.4199 13.9026V14.4666C13.4199 14.7679 13.1757 15.0121 12.8745 15.0121H12.6203C12.319 15.0121 12.0748 14.7679 12.0748 14.4666V13.9026C12.0748 13.5492 11.9079 13.4117 11.5643 13.4117H10.2541C9.95284 13.4117 9.70863 13.6559 9.70863 13.9572V16.5579C9.70863 16.8591 9.46443 17.1033 9.16318 17.1033H8.85991ZM15.6094 13.127C15.5014 15.5815 14.9123 17.1819 12.1435 17.1819C11.8809 17.1819 11.3441 17.1541 10.9519 17.1316C10.6829 17.1162 10.467 16.905 10.4436 16.6366L10.2807 14.7704C10.2529 14.4516 10.5042 14.1775 10.8241 14.1775H11.011C11.2956 14.1775 11.5324 14.3964 11.5548 14.6801L11.608 15.3553C11.6283 15.6129 11.8265 15.8224 12.0836 15.8484C12.1839 15.8586 12.2745 15.8663 12.3203 15.8663C13.9403 15.8663 14.0679 14.9237 14.1366 12.9208L14.1446 12.5608C14.1511 12.2643 14.3933 12.0273 14.6899 12.0273H15.0928C15.4055 12.0273 15.6542 12.2897 15.6375 12.602L15.6094 13.127Z\" fill=\"#414045\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bill-icon.1641876f5979f7a9f70dfbdb4a303aa8.svg"),
        {
          React: SvgBillIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      